import React, { useState, useEffect } from "react";
// import ReactFlowRenderer from "../react-flow-renderer";
// import Editor from "../../../editor/Editor";
// import ReactFlow from "../../../flowchart/ReactFlow";
// import EditorConvertToHTML from "./Editordraft";
import { TextEditor } from "./TextEditor";
// import EditorForm from "./EditorForm";
// import { Editor } from "react-draft-wysiwyg";
// import { convertToRaw, ContentState, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Editor } from "@tinymce/tinymce-react";
import "./EditorToolbar.css";
import { Link, Outlet,useNavigate } from "react-router-dom";
import { IoReorderThreeOutline } from "react-icons/io5";
import { IoMdNotificationsOutline } from "react-icons/io";
import { IoSettingsOutline } from "react-icons/io5";
import { CgProfile } from "react-icons/cg";
import { setshowDropdown } from "../../../redux/slices/user/userSlice";
import axios from "axios";
import Swal from "sweetalert2";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactFlow, {
  removeElements,
  updateEdge,
  addEdge,
  Background,
  MiniMap,
  Controls,
} from "react-flow-renderer";
import * as Yup from "yup";
import { Formik, useFormik } from "formik";
import { HiHome } from "react-icons/hi";
import ProductionListItem from "../../main/ProductionListItem";
import ManagementListItem from "../../main/ManagementListItem";
import WarehouseListItem from "../../main/WarehouseListItem";
// import { TextEditor } from "./TextEditor";
// import { ContentState } from "draft-js";
import { nodeTypes } from "../react-flow-renderer/Nodes";
import parse from "html-react-parser";
import { setNodeElements } from "../../../redux/slices/step/stepSlice";
import { useSelector, useDispatch } from "react-redux";
import { GiConsoleController } from "react-icons/gi";
import BOM from "./BOM/BOM";
import { setItemsSelected } from "../../../redux/slices/item/itemSlice";

const schema = Yup.object().shape({
  text: Yup.string().min(3).max(2000).required("Required"),
});

export default function FlowchartEditorGuide() {
  const [elements, setElements] = useState([]);
  const [double, setDouble] = useState(false);
  const [name, setName] = useState("");
  const [text, settext] = useState("");
  const dispatch = useDispatch();
  const [startname, setstartName] = useState("Start");
  const [endname, setendName] = useState("End");
  const [stepname, setstepName] = useState("Some Step");

  const Permissions = useSelector((state) => state.user.userPermissions);
  const NodesElements = useSelector((state) => state.step.NodeElements);

  const adddrawing = Permissions.find((o) => o.codename === "add_drawing");
  const viewdrawing = Permissions.find((o) => o.codename === "view_drawing");
  const [activeNode, setActiveNode] = useState();
  const [Bool, setBool] = useState(false);

  const [showsidebar, setshowsidebar] = useState(true);
  const Navigate = useNavigate();

  const showDropdown = useSelector((state) => state.user.showDropdown);

  const showdropdown = () => {
    dispatch(setshowDropdown(!showDropdown));
  };
  const DropdownItems = [
    {
      id: 1,
      Name: "User profile",
      Link: "/dashboard/user-profile",
      icon: <svg  className="mr-3 " width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.7274 20.4471C19.2716 19.1713 18.2672 18.0439 16.8701 17.2399C15.4729 16.4358 13.7611 16 12 16C10.2389 16 8.52706 16.4358 7.12991 17.2399C5.73276 18.0439 4.72839 19.1713 4.27259 20.4471" stroke="white" stroke-width="2" stroke-linecap="round"/>
      <circle cx="12" cy="8" r="4" stroke="white" stroke-width="2" stroke-linecap="round"/>
      </svg>
      ,
    },
    {
      id: 2,
      Name: "Copmany profile",
      Link:"",
      icon: <svg  className="mr-3 " width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="6" height="7" rx="1" stroke="white" stroke-width="2" stroke-linejoin="round"/>
      <rect x="4" y="15" width="6" height="5" rx="1" stroke="white" stroke-width="2" stroke-linejoin="round"/>
      <rect x="14" y="4" width="6" height="5" rx="1" stroke="white" stroke-width="2" stroke-linejoin="round"/>
      <rect x="14" y="13" width="6" height="7" rx="1" stroke="white" stroke-width="2" stroke-linejoin="round"/>
      </svg>
      ,
    },
    {
      id: 3,
      Name: "Switch company",
      Link:"",

      icon: <svg  className="mr-3 " width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 20L17.2929 20.7071L18 21.4142L18.7071 20.7071L18 20ZM13 4C12.4477 4 12 4.44771 12 5C12 5.55229 12.4477 6 13 6L13 4ZM13.2929 16.7071L17.2929 20.7071L18.7071 19.2929L14.7071 15.2929L13.2929 16.7071ZM18.7071 20.7071L22.7071 16.7071L21.2929 15.2929L17.2929 19.2929L18.7071 20.7071ZM19 20L19 9L17 9L17 20L19 20ZM14 4L13 4L13 6L14 6L14 4ZM19 9C19 6.23858 16.7614 4 14 4L14 6C15.6569 6 17 7.34315 17 9L19 9Z" fill="white"/>
      <path d="M6 4L6.70711 3.29289L6 2.58579L5.29289 3.29289L6 4ZM11 20C11.5523 20 12 19.5523 12 19C12 18.4477 11.5523 18 11 18L11 20ZM10.7071 7.29289L6.70711 3.29289L5.29289 4.70711L9.29289 8.70711L10.7071 7.29289ZM5.29289 3.29289L1.29289 7.29289L2.70711 8.70711L6.70711 4.70711L5.29289 3.29289ZM5 4L5 15L7 15L7 4L5 4ZM10 20L11 20L11 18L10 18L10 20ZM5 15C5 17.7614 7.23858 20 10 20L10 18C8.34315 18 7 16.6569 7 15L5 15Z" fill="white"/>
      </svg>
      ,
    },
    {
      id: 4,
      Name: "Notifications",
      Link:"",

      icon: <svg  className="mr-3 " width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.44784 7.96942C6.76219 5.14032 9.15349 3 12 3V3C14.8465 3 17.2378 5.14032 17.5522 7.96942L17.804 10.2356C17.8072 10.2645 17.8088 10.279 17.8104 10.2933C17.9394 11.4169 18.3051 12.5005 18.8836 13.4725C18.8909 13.4849 18.8984 13.4973 18.9133 13.5222L19.4914 14.4856C20.0159 15.3599 20.2782 15.797 20.2216 16.1559C20.1839 16.3946 20.061 16.6117 19.8757 16.7668C19.5971 17 19.0873 17 18.0678 17H5.93223C4.91268 17 4.40291 17 4.12434 16.7668C3.93897 16.6117 3.81609 16.3946 3.77841 16.1559C3.72179 15.797 3.98407 15.3599 4.50862 14.4856L5.08665 13.5222C5.10161 13.4973 5.10909 13.4849 5.11644 13.4725C5.69488 12.5005 6.06064 11.4169 6.18959 10.2933C6.19123 10.279 6.19283 10.2645 6.19604 10.2356L6.44784 7.96942Z" stroke="white" stroke-width="2"/>
      <path d="M9.10222 17.6647C9.27315 18.6215 9.64978 19.467 10.1737 20.0701C10.6976 20.6731 11.3396 21 12 21C12.6604 21 13.3024 20.6731 13.8263 20.0701C14.3502 19.467 14.7269 18.6215 14.8978 17.6647" stroke="white" stroke-width="2" stroke-linecap="round"/>
      </svg>
      ,
    },
    {
      id: 5,
      Name: "Settings",
      Link:"/dashboard/settings",

      icon: <svg  className="mr-3 " width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.08168 13.9445C2.55298 12.9941 2.28862 12.5188 2.28862 12C2.28862 11.4812 2.55298 11.0059 3.08169 10.0555L4.43094 7.63L5.85685 5.24876C6.4156 4.31567 6.69498 3.84912 7.14431 3.5897C7.59364 3.33028 8.13737 3.3216 9.22483 3.30426L12 3.26L14.7752 3.30426C15.8626 3.3216 16.4064 3.33028 16.8557 3.5897C17.305 3.84912 17.5844 4.31567 18.1431 5.24876L19.5691 7.63L20.9183 10.0555C21.447 11.0059 21.7114 11.4812 21.7114 12C21.7114 12.5188 21.447 12.9941 20.9183 13.9445L19.5691 16.37L18.1431 18.7512C17.5844 19.6843 17.305 20.1509 16.8557 20.4103C16.4064 20.6697 15.8626 20.6784 14.7752 20.6957L12 20.74L9.22483 20.6957C8.13737 20.6784 7.59364 20.6697 7.14431 20.4103C6.69498 20.1509 6.4156 19.6843 5.85685 18.7512L4.43094 16.37L3.08168 13.9445Z" stroke="white" stroke-width="2"/>
      <circle cx="12" cy="12" r="3" stroke="white" stroke-width="2"/>
      </svg>
      ,
    },
    {
      id: 6,
      Name: "Logout",
      Link:"",

      icon: <svg  className="mr-3 " width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="15" y="9" width="6" height="6" rx="2" transform="rotate(-90 15 9)" stroke="white" stroke-width="2"/>
      <path d="M6 21L3 17L6 13" stroke="white" stroke-width="2"/>
      <path d="M3 17H10C13.7712 17 15.6569 17 16.8284 15.8284C18 14.6569 18 12.7712 18 9V9" stroke="white" stroke-width="2"/>
      </svg>
      ,
    },
    
  ];

  const handleShow = () => {
    setshowsidebar(!showsidebar);
  };
  const baseURL = "https://web-production-3590.up.railway.app/"
  const getToken=()=>{
    return localStorage.getItem('token')
  }
  const LogoutHandler=()=>{
    axios.post(`${baseURL}auth/revoke-token/`, {
      client_id: "IwXZxqdvz8puzBpu1hX5mNJlQY38hDNK8tzhu6KL",
      client_secret: "Bl83aJmhAK91vmdbPtfRF0xUVPQB2Y9rrwPzYePOgYm3qbX2Rs6GF8PV3GPOGbS1p5uVVKC9YAuysagrNsMSu2wNJWALxxTc8C0HKD4rOK4vX3ajhNNNOkP9R1hmn5Ku",
      token: `${getToken()}`
    }).then((res)=>{
      console.log("Logged Out Successfully")
    }).catch((err)=>{
      console.log("error", err)
    })
    Swal.fire({
      position: "top-end",
      title: "Logged Out",
      showConfirmButton: false,
      timer: 5500,
      showClass: {
        popup: "animate__animated animate__fadeInRight",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutRight",
      },
      width: 300,
      color: "#FFFFFF",
      background: "#2A91D7",
      backdrop: `rgba(0,0,0,0)`,
    });
    Navigate("/login")
    showdropdown()
  }

  useEffect(() => {
    console.log("Active Node", activeNode);

    if (activeNode) {
      setNewName(activeNode.data.label);
      setNewtext(activeNode.data.text);
      // setnewNodes([])
      setBool(!Bool);
      console.log("newText", activeNode.data.text);
    }
    if (
      activeNode?.data?.BOM?.includes("object") ||
      activeNode?.data?.BOM === undefined ||
      activeNode?.data?.BOM === ""
    ) {
      dispatch(setItemsSelected([]));
    } else {
      dispatch(setItemsSelected(activeNode?.data?.BOM));
    }
  }, [activeNode]);

  useEffect(() => {
    console.log("newName", newName);
  }, [newName]);
  useEffect(() => {
    console.log("newtext", newtext);
  }, [newtext]);

  const formik = useFormik({
    initialValues: { text: activeNode?.data?.text },
    onSubmit: (values) => {
      console.log("Node Updating ", values);
    },
    validationSchema: schema,
  });
  const html = formik.values.text;

  const Images = [];

  const _handleUploadImage = (event, type) => {
    const config = {
      // bucketName: "moodflik-portal",
      // dirName: "img" /* optional */,
      // region: "us-east-2",
      // accessKeyId: "AKIAWFNJSIDVAQA2KNEU",
      // secretAccessKey: "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",
    };
    const file = event.target.files[0];
    console.log("clicked", file);
    Images.push(file);
    console.log("Images", Images);
    // uploadFile(file, config)
    //   .then((data) => {
    //     // if (type == "cover") {
    //     //   setCover_photo_url(data.location.replace(/ /g, "%20"));
    //     // } else {
    //     //   setProfileImage(data.location.replace(/ /g, "%20"));
    //     // }
    //   })
    //   .catch((err) => console.error(err));
  };
  
  const options = {
    replace: (domNode) => {
      if (domNode.attribs && domNode.attribs.class === "remove") {
        return <div></div>;
      }
    },
  };

  // const [state, setState] = useState({ content: "" });
  const handleChange = (content, editor) => {
    setNewtext(content);
  };

  var quillRef = null;
  // var quillObj = null;

  //UNDO and REDO function
  // export function undo() {
  //   let editor = quillRef.getEditor();
  //   return editor.history.undo();
  // }

  // export function redo() {
  //   let editor = quillRef.getEditor();
  //   return editor.history.redo();
  // }

  const modules = {
    toolbar: {
      container: [
        ["bold", "italic", "underline", "strike", "blockquote"],
        [{ size: ["small", false, "large", "huge"] }, { color: [] }],
        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
          { align: [] },
        ],
        ["link", "image", "video"],
        ["clean"],
      ],
      // handlers: { image: this.imageHandler }
    },
    clipboard: { matchVisual: false },
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "size",
    "color",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
    "align",
  ];

  const handleSubmit = (event) => {
    // alert("Text was submitted: " + state.content);
    event.preventDefault();
  };

  var [newName, setNewName] = useState("");
  var [newtext, setNewtext] = useState("");

  const [instance, setInstance] = useState();

  const elementRemoveHandler = (elementTobeRemoved) => {
    setElements((prev) => removeElements(elementTobeRemoved, prev));
  };

  const connectHandler = (params) => {
    setElements((prev) => addEdge(params, prev));
  };

  const SelectedItems = useSelector((state) => state.item.ItemsSelected);
  const [BOMItems, setBOMItems] = useState([]);

  const addRectangleHandler = () => {
    const newNode = {
      id: `${Date.now()}`,
      data: { label: `${name}`, text: `${text}`, BOM: `${SelectedItems}` },
      type: "rectangle",
      position: {
        x: 0,
        y: 0,
      },
    };
    newNode.data = { ...newNode.data, id: `${newNode.id}` };

    setElements((prev) => {
      return [...prev, newNode];
    });
    setName("");
  };
  const addStartHandler = () => {
    const newNode = {
      id: `${Date.now()}`,
      data: { label: `${startname}`, text: `${text}`, BOM: `${SelectedItems}` },
      type: "start",
      position: {
        x: 0,
        y: 0,
      },
    };
    newNode.data = { ...newNode.data, id: `${newNode.id}` };

    setElements((prev) => {
      return [...prev, newNode];
    });
    setName("");
  };
  const addDefaultHandler = () => {
    const newNode = {
      id: `${Date.now()}`,
      data: { label: `${stepname}`, text: `${text}`, BOM: `${SelectedItems}` },
      type: "defa",
      position: {
        x: 0,
        y: 0,
      },
    };
    newNode.data = { ...newNode.data, id: `${newNode.id}` };

    setElements((prev) => {
      return [...prev, newNode];
    });
    setName("");
  };
  const addEndingHandler = () => {
    const newNode = {
      id: `${Date.now()}`,
      data: { label: `${endname}`, text: `${text}`, BOM: `${SelectedItems}` },
      type: "ending",
      position: {
        x: 0,
        y: 0,
      },
    };
    newNode.data = { ...newNode.data, id: `${newNode.id}` };

    setElements((prev) => {
      return [...prev, newNode];
    });
    setName("");
  };
  const edgeUpdateHandler = (oldEdge, newConnection) =>
    setElements((els) => updateEdge(oldEdge, newConnection, els));

  const clickHandler = (e) => {
    var htmlString = e.target.outerHTML.toString();
    var index = htmlString.indexOf(` id="`);
    index += 5;
    const currentId = htmlString.substr(index, 13);
    console.log("currentId", currentId);
    elements.forEach((_current) => {
      if (_current.id === currentId) {
        setActiveNode(_current);
      }
    });

    // setNewName(activeNode.data.label)
  };
  const [count, setCount] = useState(1);
  const [countdec, setCountdec] = useState(count);

  const clickHandlerNext = (e) => {
    if (count < elements.length) {
      setCount(count + 1);
      setActiveNode(elements[count]);
      console.log("count after increment: ", count);
      console.log("activeNode", activeNode);
    } else {
      setCount(count - 1);
      console.log("count in else next", count);
      alert("End Reached");
    }

    console.log("elements", elements);

    console.log("activeNode", activeNode);

    if (!activeNode) return;
    setElements(
      elements.map((_current) => {
        if (_current.id === activeNode.id) {
          return {
            ..._current,
            data: { label: newName, text: newtext, id: _current.data.id },
          };
        }
        return _current;
      })
    );

    // setNewName(activeNode.data.label)
  };
  // && elements[count].data != {}
  const [newNodes, setnewNodes] = useState([]);
  const [newNodesSetting, setnewNodesSetting] = useState([]);

  const [Options, setOptions] = useState(false);

  const clickHandlerNext1 = (e) => {
    console.log("elements", elements);
    console.log("activeNode", activeNode);
    const newArrayEdges = elements.filter((items) => items.source > 0);
    const newArrayNodes = elements.filter((items) => items.id > 0);

    const newarrayNextEdges = newArrayEdges.filter(
      (items) => items.target === activeNode?.id
    );
    // for (let i = 0; i < newArrayNodes.length; i++) {
    //   for (let j = 0; j < newarrayNextEdges.length; j++) {
    //     if (newArrayNodes[i].id === newarrayNextEdges[j].source) {
    //       let arr = setnewNodes((prev) => [...prev, newArrayNodes[i]]);
    //       let array = [];
    //       array.push(newArrayNodes[i]);
    //       // setnewNodes(arr);
    //     }
    //   }
    // }
    let array = [];
    for (let i = 0; i < newArrayNodes.length; i++) {
      for (let j = 0; j < newarrayNextEdges.length; j++) {
        if (newArrayNodes[i].id === newarrayNextEdges[j].source) {
          // let arr = setnewNodes((prev) => [...prev, newArrayNodes[i]]);
          // setnewNodes(arr);
          // let array = [];
          array.push(newArrayNodes[i]);
        }
      }
    }

    console.log("new array....", array);
    setnewNodes(array);

    if (array.length > 1) {
      setOptions(true);
      console.log("greater than 1");
    } else {
      setOptions(false);
    }

    console.log("newArrayEdges", newArrayEdges);
    console.log("newArrayNodes", newArrayNodes);
    console.log("newarrayNextEdges", newarrayNextEdges);
    console.log("newarrayNextNodes", newNodes);
    console.log("newNodesSetting", newNodesSetting);

    if (count < newArrayNodes.length) {
      setCount(count + 1);

      setActiveNode(newArrayNodes[count]);
      // setnewNodes([])
      console.log("activeNode", activeNode);
    } else {
      setCount(count - 1);
      console.log("count in else next", count);
      alert("End Reached");
    }
  };
  // console.log("newNodesSetting", newNodesSetting);

  const clickHandlerPrevious = (e) => {
    console.log("elements", elements);
    console.log("activeNode", activeNode);
    const newArrayEdges = elements.filter((items) => items.source > 0);
    const newArrayNodes = elements.filter((items) => items.id > 0);

    if (count >= 0) {
      setCount(count - 1);

      setActiveNode(newArrayNodes[count]);
      console.log("count prevoius", count);
      console.log("activeNode", activeNode);
    } else {
      setCount(count + 1);
      console.log("count in else prevoius", count);

      alert("Upper End Reached");
    }
  };

  const handleOptionClick = (id, index) => {
    newNodes.map((items) => {
      if (items.id === id) {
        setActiveNode(items);
        setOptions(false);
      } else {
        console.log("notfound");
      }
    });
  };

  const updateNodeHandler = () => {
    if (!activeNode) return;
    setElements(
      elements.map((_current) => {
        if (_current.id === activeNode.id) {
          return {
            ..._current,
            data: {
              label: newName,
              text: newtext,
              BOM: SelectedItems,
              id: _current.data.id,
            },
          };
        }
        return _current;
      })
    );
  };

  const onLoad = (reactFlowInstance) => {
    setInstance(reactFlowInstance);
    reactFlowInstance.fitView();
  };
  const [NodesinArray, setNodesinArray] = useState([]);
  const saveChangesHandler = () => {
    console.log("current state", instance.getElements());

    // this current state instatance.getElements() storing poition of node
    // setElements(instance.getElements());
    console.log("elements", elements);

    const array = elements;
    let indexConnectedNode = 0;
    for (let i = 0; i < array.length; i++) {
      for (let j = 0; j < array.length; j++) {
        if (array[i].target === array[j].id) {
          indexConnectedNode = array.indexOf(array[j]);
          console.log("indexConnectedNode", indexConnectedNode);
        }
      }
    }

    let indexofNode = 0;
    for (let i = 0; i < array.length; i++) {
      for (let j = 0; j < array.length; j++) {
        if (array[i].source === array[j].id) {
          indexofNode = array.indexOf(array[j]);
          console.log("indexofNode...", indexofNode);
        }
      }
    }
    // array.splice(indexConnectedNode + 1, 0, array[indexofNode]);
    // array.splice(indexofNode+1, 1);

    console.log("array..", array);
    setNodesinArray(array);
    console.log("NodesinArray", NodesinArray);
    dispatch(setNodeElements(instance.getElements()));
    console.log("NodesElements", NodesElements);

    // for (var i = 0; i < newArray.length; i++) {
    //   for (var j = 0; j < newArray.length; j++) {
    //     if (newArray[i].source === newArray[j].target) {
    //       setnextNodes(newArray[j]);
    //     }
    //   }
    // }
    // const nextNodes= newArray.filter(items=>items.source===items.target)
  };

  const [showModal, setShowModal] = useState(false);

  const [status, setStatus] = useState(true); // 0: no show, 1: show yes, 2: show no.

  const ButtonHandler = (status) => {
    setStatus(status);
  };
  const [statusstep, setStatusstep] = useState(false); // 0: no show, 1: show yes, 2: show no.
  const [statusstep1, setStatusstep1] = useState(false); // 0: no show, 1: show yes, 2: show no.

  const Buttonstep1Handler = (statusstep1) => {
    setStatusstep1(statusstep1);
  };
  const ButtonstepHandler = (statusstep) => {
    setStatusstep(statusstep);
  };
  const [statusreport, setStatusreport] = useState(true); // 0: no show, 1: show yes, 2: show no.
  const [EditBom, setEditBom] = useState(false); // 0: no show, 1: show yes, 2: show no.

  const ButtonreportHandler = (statusreport) => {
    setStatusreport(statusreport);
  };
  const [statusprint, setStatusprint] = useState(true); // 0: no show, 1: show yes, 2: show no.

  const ButtonprintHandler = (statusprint) => {
    setStatusprint(statusprint);
  };
  const onChangeContents = (contents) => {
    // let _contents = null;
    console.log("contents start", contents);

    setNewtext(contents);
    console.log("contents", contents);
  };
  return (
    <div
    // className=' -ml-10 -mr-10'
    >
    <nav className=" w-full font-Roboto ">
        <div className="max-w-full  px-4 ">
          <div className="flex flex-1 justify-between">
            <div className="flex flex-grow-1 space-x-7">
              <div>
                <Link to="/" className="flex items-center py-4 px-2">
                  <svg
                    width="42"
                    height="53"
                    viewBox="0 0 42 53"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M41.0188 31.2696C41.0188 37.0055 38.8687 42.5064 35.0415 46.5623C31.2143 50.6182 26.0235 52.8968 20.611 52.8968C15.1985 52.8968 10.0077 50.6182 6.18044 46.5623C2.35323 42.5064 0.203125 37.0055 0.203125 31.2696C0.203125 25.8428 2.39475 19.5892 6.7181 12.6833C6.84708 12.4772 7.01314 12.3001 7.20678 12.1622C7.40042 12.0242 7.61784 11.928 7.84658 11.8792C8.07533 11.8304 8.31092 11.8299 8.53986 11.8776C8.7688 11.9254 8.9866 12.0206 9.1808 12.1577L16.3404 17.2161L23.1837 1.98629C23.3057 1.71457 23.4875 1.47786 23.7138 1.29605C23.9401 1.11424 24.2042 0.992635 24.4841 0.941456C24.7639 0.890277 25.0512 0.911019 25.3219 1.00194C25.5926 1.09286 25.8387 1.2513 26.0397 1.46395C29.3102 4.92384 33.0447 9.12093 35.945 14.0155C39.3589 19.7773 41.0188 25.4213 41.0188 31.2696Z"
                      fill="#00EDDF"
                    />
                    <path
                      d="M20.611 52.8984C26.0235 52.8984 31.2143 50.6198 35.0415 46.5639C30.8057 32.9473 26.7826 26.4718 16.3404 17.2177L9.1808 12.1592C8.9866 12.0221 8.7688 11.927 8.53986 11.8792C8.31092 11.8314 8.07533 11.8319 7.84658 11.8808C7.61784 11.9296 7.40042 12.0257 7.20678 12.1637C7.01314 12.3017 6.84708 12.4788 6.7181 12.6849C2.39475 19.5908 0.203125 25.8443 0.203125 31.2711C0.203125 37.007 2.35323 42.508 6.18044 46.5639C10.0077 50.6198 15.1985 52.8984 20.611 52.8984Z"
                      fill="#2A91D7"
                    />
                  </svg>

                  <span className="font-extrabold text-blue-200 text-3xl px-1">
                    Fabrik
                  </span>
                </Link>
              </div>
            </div>

            <div className="flex-1">
          <div className="flex justify-between pt-10 h-12 items-center">
            <div>
              <button className="py-6 px-4" onClick={handleShow}>
                <IoReorderThreeOutline size={30} />
              </button>
            </div>
            <div className="flex justify-start items-center pr-2 space-x-3">
              <IoMdNotificationsOutline size={30} />
              <IoSettingsOutline size={30} />
              {/* <Link to="/dashboard/user-profile"> */}
                <CgProfile size={30} className="cursor-pointer"  onClick={() => {
                      showdropdown();
                    }}/>
              {/* </Link> */}
              {showDropdown ? (
            <div className="absolute rounded-lg bg-blue-200 top-12 right-8 ">
              <ul className="py-2 text-normal text-white px-4">
              {DropdownItems.map((items) => (
                <li key={items.id}>
                  {items.Name === "Logout" ? (  
                  <a
                    className="flex py-2 px-4  hover:bg-blue-100 border-b border-white active:text-white cursor-pointer focus:text-white"
                    onClick={() =>{LogoutHandler(); dispatch(setshowDropdown(false));}}
                  >
                    {items.icon}
                    {items.Name}
                  </a>):(  <a
                    className="flex py-2 px-4  hover:bg-blue-100 border-b border-white active:text-white cursor-pointer  focus:text-white"
                    onClick={()=>{Navigate(items.Link); dispatch(setshowDropdown(false));}}
                  >
                    {items.icon}
                    {items.Name}
                  </a>)}
                </li>
 ))}
               
              </ul>
            </div>
          ) : null}
              <div></div>
            </div>
          </div>
          
        </div>
          </div>
        </div>
      </nav>
      <nav class="bg-blue-200 border-gray-200 px-2 sm:px-4 py-2.5 ">
        <div class="container flex flex-wrap justify-between items-center ml-auto">
          <div
            class="hidden w-full ml-auto md:block md:w-auto font-Montserrat"
            id="navbar-default"
          >
            <ul class="flex flex-col mt-4 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium">
              <li className="flex pt-1">
                <a
                  href="#"
                  class="block py-2 pr-4 pl-3 text-gray-200  border-b border-gray-100 md:border-0 md:p-0  "
                >
                  Build :
                </a>
                <span class="text-white ml-0.5"> Something</span>
              </li>
              <li className="flex pt-1">
                <a
                  href="#"
                  class="block py-2 pr-4 pl-3 text-gray-200  border-b border-gray-100 md:border-0 md:p-0"
                >
                  Product :
                </a>
                <span class="text-white ml-0.5"> Something</span>
              </li>
              <li className="flex pt-1">
                <a
                  href="#"
                  class="block py-2 pr-4 pl-3 text-gray-200  border-b border-gray-100 md:border-0 md:p-0"
                >
                  Version :
                </a>
                <span class="text-white ml-0.5"> 1 V</span>
              </li>
              <li>
                <button
                  type="submit"
                  className="text-white mr-8 float-left bg-green-100 hover:bg-green-200 font-Montserrat font-medium  place-content-center rounded-md pt-1 pb-1 px-4 flex flex-shrink-1 "
                >
                  <svg
                    className="mr-1 mt-1"
                    width="12"
                    height="12"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 2L12 8L2 13"
                      stroke="white"
                      stroke-width="1.5"
                    />
                    <circle cx="2" cy="2" r="2" fill="white" />
                    <circle cx="12" cy="8" r="2" fill="white" />
                    <circle cx="2" cy="13" r="2" fill="white" />
                  </svg>
                  Share
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div className="flex min-h-screen">

      {showsidebar && (
        <div className="hidden min-w-max bg-blue-200 border-r border-blue-200 rounded-r-lg">
          
          <div className="flex py-4 px-4 ml-4 mr-4 items-center">
            <Link to="/dashboard" className=" flex items-center ">
              <svg
                width="22"
                height="19"
                viewBox="0 0 22 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.69893 0.802157C10.0615 0.491232 10.5233 0.320312 11.0009 0.320312C11.4785 0.320312 11.9404 0.491232 12.3029 0.802157L18.6389 6.23216L21.1259 8.22216C21.2285 8.30423 21.3139 8.40571 21.3772 8.52078C21.4406 8.63586 21.4806 8.76229 21.4951 8.89285C21.5096 9.02341 21.4982 9.15554 21.4617 9.28171C21.4251 9.40787 21.364 9.52559 21.2819 9.62816C21.1999 9.73072 21.0984 9.81611 20.9833 9.87946C20.8682 9.9428 20.7418 9.98286 20.6112 9.99735C20.4807 10.0118 20.3485 10.0005 20.2224 9.96388C20.0962 9.92731 19.9785 9.86623 19.8759 9.78416L19.0009 9.08416V17.0032C19.0009 17.5336 18.7902 18.0423 18.4151 18.4174C18.0401 18.7924 17.5314 19.0032 17.0009 19.0032H13.0009V14.0032C13.0009 13.4727 12.7902 12.964 12.4151 12.5889C12.0401 12.2139 11.5314 12.0032 11.0009 12.0032C10.4705 12.0032 9.96179 12.2139 9.58672 12.5889C9.21164 12.964 9.00093 13.4727 9.00093 14.0032V19.0032H5.00093C4.4705 19.0032 3.96179 18.7924 3.58672 18.4174C3.21164 18.0423 3.00093 17.5336 3.00093 17.0032V9.08316L2.12593 9.78316C2.02406 9.87014 1.90576 9.93577 1.77804 9.97615C1.65033 10.0165 1.5158 10.0309 1.38244 10.0182C1.24909 10.0056 1.11962 9.96636 1.00174 9.90276C0.883849 9.83916 0.779942 9.75252 0.696182 9.64799C0.612422 9.54346 0.550517 9.42316 0.514142 9.29424C0.477766 9.16533 0.467661 9.03042 0.484426 8.89752C0.501192 8.76462 0.544486 8.63645 0.611739 8.52061C0.678992 8.40476 0.768833 8.30361 0.87593 8.22316L3.36293 6.23316L9.69893 0.802157Z"
                  fill="white"
                />
              </svg>

              <h2 className="text-white text-base font-Roboto px-2">
                Dashboard
              </h2>
            </Link>
          </div>
          <div className="ml-4 mr-4">
            <ProductionListItem showSideBar={showsidebar} />
            <WarehouseListItem showSideBar={showsidebar} />
            <ManagementListItem showSideBar={showsidebar} />
          </div>
        </div>
      )}

      {/* mini profile */}
      {!showsidebar && (
        <div className="min-w-max bg-blue-200 border-r border-blue-200 rounded-r-lg flex flex-col items-center">
         
          <div className="flex py-4 px-4 ">
            <Link to="/dashboard" className=" flex items-center mb-2 ">
              <HiHome size={25} color="#FFFFFF" />
            </Link>
          </div>
          <div className="">
            <ProductionListItem showSideBar={showsidebar} />
            <WarehouseListItem showSideBar={showsidebar} />
            <ManagementListItem showSideBar={showsidebar} />
          </div>
        </div>
      )}
      
      <div class="contents justify-center ">
        <div className="w-full flex-4 sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6   rounded-xl mr-6 ">
          {statusstep1 === false ? (
            <div class="flex flex-wrap justify-center ">
              <div className={ `w-full  flex-1 ml-1 sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4  rounded-xl mr-6 `}>
                <div
                  style={{
                    // height: "90vh",
                    height: "100%",
                    // width: "55vw",
                    // border: "1px solid black",
                    // marginLeft: "2.5vw",
                  }}
                  className="border-1 border-blue-200  w-11/12"
                >
                  <ReactFlow
                    elements={elements}
                    onElementsRemove={elementRemoveHandler}
                    onConnect={connectHandler}
                    deleteKeyCode={8 || 46}
                    onEdgeUpdate={edgeUpdateHandler}
                    nodeTypes={nodeTypes}
                    snapToGrid={true}
                    snapGrid={[16, 16]}
                    connectionLineStyle={{ stroke: "red", strokeWidth: 2 }}
                    onClick={clickHandler}
                    onLoad={onLoad}
                    fitView
                  >
                    <Background gap={5} size={1} color="#aaa" />

                    <Controls />
                  </ReactFlow>
                </div>
                <div className="flex ml-4 mt-2">
                  <button
                    type="button"
                    className=" text-white px-2 bg-green-100 hover:bg-green-200 focus:bg-green-200 font-Montserrat rounded-md cursor-pointer"
                    // onClick={addStartHandler}
                    disabled={double}
                    onClick={() => {
                      addStartHandler();
                      setDouble(true);
                    }}
                  >
                    Start Node
                  </button>
                  {double ? (
                    <>
                      <button
                        type="button"
                        className=" text-blue-200 px-2 bg-white hover:bg-blue-200 hover:text-white focus:bg-blue-200 focus:text-white font-Montserrat mx-1 rounded-md cursor-pointer"
                        onClick={addDefaultHandler}
                      >
                        Default Node
                      </button>
                      <button
                        type="button"
                        className=" text-red-700 px-2 bg-white hover:bg-red-700 hover:text-white focus:bg-red-700 focus:text-white font-Montserrat rounded-md cursor-pointer"
                        onClick={addEndingHandler}
                      >
                        End Node
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        disabled
                        type="button"
                        className=" text-blue-200 px-2 bg-white cursor-not-allowed opacity-50  focus:bg-blue-200 focus:text-white font-Montserrat mx-1 rounded-md "
                        onClick={addDefaultHandler}
                      >
                        Default Node
                      </button>
                      <button
                        type="button"
                        disabled
                        className=" text-red-700 px-2 bg-white cursor-not-allowed opacity-50  focus:bg-red-700 focus:text-white font-Montserrat rounded-md "
                        onClick={addEndingHandler}
                      >
                        End Node
                      </button>
                    </>
                  )}
                </div>
              </div>
              {/* w-72 h-72 if my buttons required */}

              <div className="mt-2  font-Montserrat flex-2 sm:w-1/2  md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6 ml-4">
                {statusstep ? (
                  <div>
                    {" "}
                    {status === true ? (
                      <div>
                        <div
                          className=" space-x-15 bg-transparent  rounded-lg  pt-4 pr-8 "
                          // style={{ width: "85vw" }}
                        >
                        <div className="flex">

                        <label className="text-black font-Montserrat font-semibold self-center mr-1 text-sm"> Node Name:</label>

                          <input
                            value={newName}
                            onChange={(e) => setNewName(e.target.value)}
                            type="text"
                            placeholder="Update node Label"
                            class="block ml-1 py-2.5 px-0 w-2/3 text-sm text-gray-900 bg-transparent border-0 border-b-2 outline-none border-gray-200   "
                          />
                          </div>
                          <br />
                          <ReactQuill
                            onRef={(el) => (quillRef = el)}
                            value={newtext}
                            onChange={onChangeContents}
                            theme="snow"
                            modules={modules}
                            formats={formats}
                          />

                          <br />
                        </div>

                        <>
                          <div className="flex flex-row justify-between relative bottom-40 space-x-15 bg-white shadow-lg border-1 border-blue-200 rounded-lg md:space-x-10 sm:space-x-5 p-4">
                            <button
                              type="button"
                              className="text-red-600 font-Montserrat "
                            >
                              Go Back
                            </button>

                            {activeNode === undefined ? (
                              <>
                                <button
                                  type="button"
                                  disabled
                                  class="text-blue-200  font-Montserrat font-medium px-2 bg-transparent cursor-not-allowed opacity-50  focus:outline-none  rounded-lg  pr-5 py-2.5 text-center inline-flex items-center mb-2"
                                >
                                  <svg
                                    className="pr-2"
                                    width="20"
                                    height="17"
                                    viewBox="0 0 21 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M0 8.5H21M10.5 0.5V16.5"
                                      stroke="#1F78B4"
                                      stroke-width="2"
                                    />
                                  </svg>
                                  Upload File
                                </button>
                                <button
                                  type="button"
                                  disabled
                                  class="text-blue-200  font-Montserrat font-semibold px-2  bg-transparent cursor-not-allowed opacity-50  focus:outline-none  rounded-lg  pr-3 py-2.5 text-center inline-flex items-center   mb-2"
                                  // style={{ marginLeft: "auto", marginRight: "2px" }}
                                  onClick={() => {
                                    setEditBom(true);
                                  }}
                                >
                                  <svg
                                    className="mr-1 mt-0.5"
                                    width="22"
                                    height="20"
                                    viewBox="0 0 22 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_807_4358)">
                                      <path
                                        d="M6.94498 18.8033L0.788086 20L2.03052 14.0625L6.94498 18.8033ZM3.25222 12.8833L8.16668 17.6242L21.5242 4.74083L16.6089 0L3.25222 12.8833Z"
                                        fill="#1F78B4"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_807_4358">
                                        <rect
                                          width="20.7361"
                                          height="20"
                                          fill="white"
                                          transform="translate(0.787109)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  Edit BOM
                                </button>
                                {EditBom ? (
                                  <div>
                                    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                                      <div className="relative my-auto mx-auto lg:max-w-xl md:max-w-lg">
                                        {/*content*/}
                                        <div
                                          className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none"
                                          style={{ width: "45vw" }}
                                        >
                                          {/*header*/}
                                          <button
                                            type="button"
                                            class="text-red-400  font-Montserrat ml-auto bg-transparent font-semibold hover:bg-blue-50   focus:outline-none  rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center  mr-2 mb-2"
                                            onClick={() => setEditBom(false)}
                                          >
                                            <svg
                                              className="mr-1"
                                              width="12"
                                              height="13"
                                              viewBox="0 0 12 13"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M1 1.5L11 11.5M1 11.5L11 1.5"
                                                stroke="#E40000"
                                                stroke-opacity="0.6"
                                                stroke-width="2"
                                              />
                                            </svg>
                                            Close
                                          </button>
                                          <div className=" ml-3 flex items-start justify-between -mt-8 w-fit rounded-t">
                                            <h2 className="font-Montserrat text-xl font-bold text-black">
                                              Build of Material
                                            </h2>
                                          </div>

                                          {/*body*/}
                                          <div className="relative p-6 flex overflow-auto">
                                            <BOM />
                                          </div>
                                          {/*footer
                                      <div className="flex p-6 border-t border-solid border-slate-200 rounded-b">
                                        <div className="float-left">
                                          <button
                                            className="text-red-500  background-transparent text-lg px-6 py-2  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setEditBom(false)}
                                          >
                                            Cancel
                                          </button>
                                        </div>
                                        <div className="float-right ml-auto">
                                          <button
                                            className="bg-green-100 hover:bg-green-200 text-white active:bg-emerald-600 font-bold  text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setEditBom(false)}
                                          >
                                            Save BOM
                                          </button>
                                        </div>
                                      </div>*/}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                                  </div>
                                ) : null}
                                <button
                                  type="submit"
                                  disabled
                                  className=" float-left text-green-100 cursor-not-allowed opacity-50 font-semibold font-Montserrat place-content-center rounded-md pt-2  flex "
                                  // style={{ marginLeft: "-6px" }}
                                  onClick={() => {
                                    console.log("it is pressesd");
                                    updateNodeHandler();
                                    saveChangesHandler();
                                  }}
                                >
                                  <svg
                                    className="mr-1"
                                    width="22"
                                    height="24"
                                    viewBox="0 0 22 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M13 3H15.997V8H13V3ZM22 4V24H0V0H17.997L22 4ZM5 9H17V2H5V9ZM19 13H3V22H19V13Z"
                                      fill="#5DAD38"
                                    />
                                  </svg>
                                  Save Changes
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  type="button"
                                  class="text-blue-200  font-Montserrat font-medium px-2 bg-transparent hover:bg-blue-50  focus:outline-none  rounded-lg  pr-5 py-2.5 text-center inline-flex items-center mb-2"
                                >
                                  <svg
                                    className="pr-2"
                                    width="20"
                                    height="17"
                                    viewBox="0 0 21 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M0 8.5H21M10.5 0.5V16.5"
                                      stroke="#1F78B4"
                                      stroke-width="2"
                                    />
                                  </svg>
                                  Upload File
                                </button>
                                <button
                                  type="button"
                                  class="text-blue-200  font-Montserrat font-semibold px-2  bg-transparent hover:bg-blue-50   focus:outline-none  rounded-lg  pr-3 py-2.5 text-center inline-flex items-center   mb-2"
                                  // style={{ marginLeft: "auto", marginRight: "2px" }}
                                  onClick={() => {
                                    setEditBom(true);
                                  }}
                                >
                                  <svg
                                    className="mr-1 mt-0.5"
                                    width="22"
                                    height="20"
                                    viewBox="0 0 22 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_807_4358)">
                                      <path
                                        d="M6.94498 18.8033L0.788086 20L2.03052 14.0625L6.94498 18.8033ZM3.25222 12.8833L8.16668 17.6242L21.5242 4.74083L16.6089 0L3.25222 12.8833Z"
                                        fill="#1F78B4"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_807_4358">
                                        <rect
                                          width="20.7361"
                                          height="20"
                                          fill="white"
                                          transform="translate(0.787109)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  Edit BOM
                                </button>
                                {EditBom ? (
                                  <div>
                                    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                                      <div className="relative my-auto mx-auto lg:max-w-xl md:max-w-lg">
                                        {/*content*/}
                                        <div
                                          className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none"
                                          style={{ width: "45vw" }}
                                        >
                                          {/*header*/}
                                          <button
                                            type="button"
                                            class="text-red-400  font-Montserrat ml-auto bg-transparent font-semibold hover:bg-blue-50   focus:outline-none  rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center  mr-2 mb-2"
                                            onClick={() => setEditBom(false)}
                                          >
                                            <svg
                                              className="mr-1"
                                              width="12"
                                              height="13"
                                              viewBox="0 0 12 13"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M1 1.5L11 11.5M1 11.5L11 1.5"
                                                stroke="#E40000"
                                                stroke-opacity="0.6"
                                                stroke-width="2"
                                              />
                                            </svg>
                                            Close
                                          </button>
                                          <div className=" ml-3 flex items-start justify-between -mt-8 w-fit rounded-t">
                                            <h2 className="font-Montserrat text-xl font-bold text-black">
                                              Build of Material
                                            </h2>
                                          </div>

                                          {/*body*/}
                                          <div className="relative p-6 flex overflow-auto">
                                            <BOM />
                                          </div>
                                          {/*footer
                                      <div className="flex p-6 border-t border-solid border-slate-200 rounded-b">
                                        <div className="float-left">
                                          <button
                                            className="text-red-500  background-transparent text-lg px-6 py-2  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setEditBom(false)}
                                          >
                                            Cancel
                                          </button>
                                        </div>
                                        <div className="float-right ml-auto">
                                          <button
                                            className="bg-green-100 hover:bg-green-200 text-white active:bg-emerald-600 font-bold  text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setEditBom(false)}
                                          >
                                            Save BOM
                                          </button>
                                        </div>
                                      </div>*/}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                                  </div>
                                ) : null}
                                <button
                                  type="submit"
                                  className=" float-left text-green-100 font-semibold font-Montserrat place-content-center rounded-md pt-2  flex "
                                  // style={{ marginLeft: "-6px" }}
                                  onClick={() => {
                                    console.log("it is pressesd");
                                    updateNodeHandler();
                                    saveChangesHandler();
                                  }}
                                >
                                  <svg
                                    className="mr-1"
                                    width="22"
                                    height="24"
                                    viewBox="0 0 22 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M13 3H15.997V8H13V3ZM22 4V24H0V0H17.997L22 4ZM5 9H17V2H5V9ZM19 13H3V22H19V13Z"
                                      fill="#5DAD38"
                                    />
                                  </svg>
                                  Save Changes
                                </button>
                              </>
                            )}
                          </div>
                        </>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                ) : (
                  <div>
                    {" "}
                    {status === true ? (
                      <div>
                        <div
                          className=" space-x-15 bg-transparent  rounded-lg  pt-4 pr-8 "
                          // style={{ width: "85vw" }}
                        >
                        <div className="flex">

                        <label className="text-black font-Montserrat font-semibold self-center mr-1 text-sm"> Node Name:</label>

                          <input
                            value={newName}
                            onChange={(e) => setNewName(e.target.value)}
                            type="text"
                            placeholder="Update node Label"
                            class="block ml-1 py-2.5 px-0 w-2/3 text-sm text-gray-900 bg-transparent border-0 outline-none border-b-2 border-gray-200   "
                          />
                          </div>
                          <br />
                          <ReactQuill
                            onRef={(el) => (quillRef = el)}
                            value={newtext}
                            onChange={onChangeContents}
                            theme="snow"
                            modules={modules}
                            formats={formats}
                          />

                          <br />
                        </div>

                        <>
                          <div className="flex flex-row justify-between relative bottom-40 space-x-15 bg-white shadow-lg border-1 border-blue-200 rounded-lg md:space-x-10 sm:space-x-5 p-4">
                            <button
                              type="button"
                              className="text-red-600 font-Montserrat "
                            >
                              Go Back
                            </button>
                            {activeNode === undefined ? (
                              <>
                                <button
                                  type="button"
                                  disabled
                                  class="text-blue-200  font-Montserrat font-medium px-2 bg-transparent cursor-not-allowed opacity-50  focus:outline-none  rounded-lg  pr-5 py-2.5 text-center inline-flex items-center mb-2"
                                >
                                  <svg
                                    className="pr-2"
                                    width="20"
                                    height="17"
                                    viewBox="0 0 21 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M0 8.5H21M10.5 0.5V16.5"
                                      stroke="#1F78B4"
                                      stroke-width="2"
                                    />
                                  </svg>
                                  Upload File
                                </button>
                                <button
                                  type="button"
                                  disabled
                                  class="text-blue-200  font-Montserrat font-semibold px-2  bg-transparent cursor-not-allowed opacity-50   focus:outline-none  rounded-lg  pr-3 py-2.5 text-center inline-flex items-center   mb-2"
                                  // style={{ marginLeft: "auto", marginRight: "2px" }}
                                  onClick={() => {
                                    setEditBom(true);
                                  }}
                                >
                                  <svg
                                    className="mr-1 mt-0.5"
                                    width="22"
                                    height="20"
                                    viewBox="0 0 22 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_807_4358)">
                                      <path
                                        d="M6.94498 18.8033L0.788086 20L2.03052 14.0625L6.94498 18.8033ZM3.25222 12.8833L8.16668 17.6242L21.5242 4.74083L16.6089 0L3.25222 12.8833Z"
                                        fill="#1F78B4"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_807_4358">
                                        <rect
                                          width="20.7361"
                                          height="20"
                                          fill="white"
                                          transform="translate(0.787109)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  Edit BOM
                                </button>
                                {EditBom ? (
                                  <div>
                                    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                                      <div className="relative my-auto mx-auto lg:max-w-xl md:max-w-lg">
                                        {/*content*/}
                                        <div
                                          className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none"
                                          style={{ width: "45vw" }}
                                        >
                                          {/*header*/}
                                          <button
                                            type="button"
                                            class="text-red-400  font-Montserrat ml-auto bg-transparent font-semibold hover:bg-blue-50   focus:outline-none  rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center  mr-2 mb-2"
                                            onClick={() => setEditBom(false)}
                                          >
                                            <svg
                                              className="mr-1"
                                              width="12"
                                              height="13"
                                              viewBox="0 0 12 13"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M1 1.5L11 11.5M1 11.5L11 1.5"
                                                stroke="#E40000"
                                                stroke-opacity="0.6"
                                                stroke-width="2"
                                              />
                                            </svg>
                                            Close
                                          </button>
                                          <div className=" ml-3 flex items-start justify-between -mt-8 w-fit rounded-t">
                                            <h2 className="font-Montserrat text-xl font-bold text-black">
                                              Build of Material
                                            </h2>
                                          </div>

                                          {/*body*/}
                                          <div className="relative p-6 flex overflow-auto">
                                            <BOM />
                                          </div>
                                          {/*footer
                                      <div className="flex p-6 border-t border-solid border-slate-200 rounded-b">
                                        <div className="float-left">
                                          <button
                                            className="text-red-500  background-transparent text-lg px-6 py-2  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setEditBom(false)}
                                          >
                                            Cancel
                                          </button>
                                        </div>
                                        <div className="float-right ml-auto">
                                          <button
                                            className="bg-green-100 hover:bg-green-200 text-white active:bg-emerald-600 font-bold  text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setEditBom(false)}
                                          >
                                            Save BOM
                                          </button>
                                        </div>
                                      </div>*/}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                                  </div>
                                ) : null}
                                <button
                                  type="submit"
                                  disabled
                                  className=" float-left text-green-100 cursor-not-allowed opacity-50 font-semibold font-Montserrat place-content-center rounded-md pt-2  flex "
                                  // style={{ marginLeft: "-6px" }}
                                  onClick={() => {
                                    console.log("it is pressesd");
                                    updateNodeHandler();
                                    saveChangesHandler();
                                  }}
                                >
                                  <svg
                                    className="mr-1"
                                    width="22"
                                    height="24"
                                    viewBox="0 0 22 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M13 3H15.997V8H13V3ZM22 4V24H0V0H17.997L22 4ZM5 9H17V2H5V9ZM19 13H3V22H19V13Z"
                                      fill="#5DAD38"
                                    />
                                  </svg>
                                  Save Changes
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  type="button"
                                  class="text-blue-200  font-Montserrat font-medium px-2 bg-transparent hover:bg-blue-50  focus:outline-none  rounded-lg  pr-5 py-2.5 text-center inline-flex items-center mb-2"
                                >
                                  <svg
                                    className="pr-2"
                                    width="20"
                                    height="17"
                                    viewBox="0 0 21 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M0 8.5H21M10.5 0.5V16.5"
                                      stroke="#1F78B4"
                                      stroke-width="2"
                                    />
                                  </svg>
                                  Upload File
                                </button>
                                <button
                                  type="button"
                                  class="text-blue-200  font-Montserrat font-semibold px-2  bg-transparent hover:bg-blue-50   focus:outline-none  rounded-lg  pr-3 py-2.5 text-center inline-flex items-center   mb-2"
                                  // style={{ marginLeft: "auto", marginRight: "2px" }}
                                  onClick={() => {
                                    setEditBom(true);
                                  }}
                                >
                                  <svg
                                    className="mr-1 mt-0.5"
                                    width="22"
                                    height="20"
                                    viewBox="0 0 22 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_807_4358)">
                                      <path
                                        d="M6.94498 18.8033L0.788086 20L2.03052 14.0625L6.94498 18.8033ZM3.25222 12.8833L8.16668 17.6242L21.5242 4.74083L16.6089 0L3.25222 12.8833Z"
                                        fill="#1F78B4"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_807_4358">
                                        <rect
                                          width="20.7361"
                                          height="20"
                                          fill="white"
                                          transform="translate(0.787109)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  Edit BOM
                                </button>
                                {EditBom ? (
                                  <div>
                                    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                                      <div className="relative my-auto mx-auto lg:max-w-xl md:max-w-lg">
                                        {/*content*/}
                                        <div
                                          className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none"
                                          style={{ width: "45vw" }}
                                        >
                                          {/*header*/}
                                          <button
                                            type="button"
                                            class="text-red-400  font-Montserrat ml-auto bg-transparent font-semibold hover:bg-blue-50   focus:outline-none  rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center  mr-2 mb-2"
                                            onClick={() => setEditBom(false)}
                                          >
                                            <svg
                                              className="mr-1"
                                              width="12"
                                              height="13"
                                              viewBox="0 0 12 13"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M1 1.5L11 11.5M1 11.5L11 1.5"
                                                stroke="#E40000"
                                                stroke-opacity="0.6"
                                                stroke-width="2"
                                              />
                                            </svg>
                                            Close
                                          </button>
                                          <div className=" ml-3 flex items-start justify-between -mt-8 w-fit rounded-t">
                                            <h2 className="font-Montserrat text-xl font-bold text-black">
                                              Build of Material
                                            </h2>
                                          </div>

                                          {/*body*/}
                                          <div className="relative p-6 flex overflow-auto">
                                            <BOM />
                                          </div>
                                          {/*footer
                                      <div className="flex p-6 border-t border-solid border-slate-200 rounded-b">
                                        <div className="float-left">
                                          <button
                                            className="text-red-500  background-transparent text-lg px-6 py-2  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setEditBom(false)}
                                          >
                                            Cancel
                                          </button>
                                        </div>
                                        <div className="float-right ml-auto">
                                          <button
                                            className="bg-green-100 hover:bg-green-200 text-white active:bg-emerald-600 font-bold  text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setEditBom(false)}
                                          >
                                            Save BOM
                                          </button>
                                        </div>
                                      </div>*/}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                                  </div>
                                ) : null}
                                <button
                                  type="submit"
                                  className=" float-left text-green-100 font-semibold font-Montserrat place-content-center rounded-md pt-2  flex "
                                  // style={{ marginLeft: "-6px" }}
                                  onClick={() => {
                                    console.log("it is pressesd");
                                    updateNodeHandler();
                                    saveChangesHandler();
                                  }}
                                >
                                  <svg
                                    className="mr-1"
                                    width="22"
                                    height="24"
                                    viewBox="0 0 22 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M13 3H15.997V8H13V3ZM22 4V24H0V0H17.997L22 4ZM5 9H17V2H5V9ZM19 13H3V22H19V13Z"
                                      fill="#5DAD38"
                                    />
                                  </svg>
                                  Save Changes
                                </button>
                              </>
                            )}
                          </div>
                        </>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                )}
              </div>
            </div>
          ) : null}
        </div>
        <div className="max-w-max h-screen font-Montserrat flex-1 p-4 bg-white border-1 border-blue-200 ml-4" style={{height:"95vh"}}>
          <div className="flex flex-wrap  mt-1  rounded-xl">
            <div className="flex flex-wrap m-auto float-left">
              <div
                className=" text-blue-200 cursor-pointer  py-4 font-medium "
                onClick={() => ButtonHandler(!status)}
              >
                {status ? (
                  <svg
                    width="35"
                    height="35"
                    viewBox="0 0 35 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                  >
                    <mask
                      id="mask0_938_5934"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="35"
                      height="35"
                    >
                      <rect width="35" height="35" fill="url(#pattern0)" />
                    </mask>
                    <g mask="url(#mask0_938_5934)">
                      <rect width="35" height="35" fill="#1F78B4" />
                    </g>
                    <defs>
                      <pattern
                        id="pattern0"
                        patternContentUnits="objectBoundingBox"
                        width="1"
                        height="1"
                      >
                        <use
                          xlinkHref="#image0_938_5934"
                          transform="scale(0.00195312)"
                        />
                      </pattern>
                      <image
                        id="image0_938_5934"
                        width="512"
                        height="512"
                        xlinkHref="data:image/png;base64,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"
                      />
                    </defs>
                  </svg>
                ) : (
                  <svg
                    width="35"
                    height="35"
                    viewBox="0 0 35 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                  >
                    <mask
                      id="mask0_973_3983"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="35"
                      height="35"
                    >
                      <rect width="35" height="35" fill="url(#pattern0)" />
                    </mask>
                    <g mask="url(#mask0_973_3983)">
                      <rect width="35" height="35" fill="#1F78B4" />
                    </g>
                    <defs>
                      <pattern
                        id="pattern0"
                        patternContentUnits="objectBoundingBox"
                        width="1"
                        height="1"
                      >
                        <use
                          xlinkHref="#image0_973_3983"
                          transform="scale(0.00195312)"
                        />
                      </pattern>
                      <image
                        id="image0_973_3983"
                        width="512"
                        height="512"
                        xlinkHref="data:image/png;base64,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"
                      />
                    </defs>
                  </svg>
                )}
                BOM
              </div>
            </div>
          </div>
          <div className="flex flex-wrap  mt-1  rounded-xl">
            <div className="flex flex-wrap m-auto float-left ">
              <div
                className=" text-blue-200 cursor-pointer py-4 font-medium "
                onClick={() => {
                  ButtonstepHandler(!statusstep);
                  Buttonstep1Handler(!statusstep1);
                }}
              >
                {statusstep ? (
                  <svg
                    width="35"
                    height="35"
                    viewBox="0 0 35 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M30.0198 4.98313L22.4452 25.2146L19.9033 15.0952L9.79417 12.5679L30.0198 4.98313ZM35 0L0 13.125L17.5 17.5L21.8954 35L35 0Z"
                      fill="#1F78B4"
                    />
                  </svg>
                ) : (
                  <svg
                    width="35"
                    height="35"
                    viewBox="0 0 35 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 13.125L35 0L21.8954 35L17.5 17.5L0 13.125Z"
                      fill="#1F78B4"
                    />
                  </svg>
                )}
                Steps
              </div>
            </div>
          </div>
          <div className="flex flex-wrap  mt-1  rounded-xl">
            <div className="flex flex-wrap m-auto float-left ">
              <div
                className=" text-blue-200 cursor-pointer py-4 font-medium "
                onClick={() => {
                  ButtonreportHandler(!statusreport);
                  setShowModal(true);
                }}
              >
                {statusreport ? (
                  <svg
                    className="ml-2"
                    width="35"
                    height="35"
                    viewBox="0 0 35 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.5 7.54962L30.0869 30.6248H4.91313L17.5 7.54962ZM17.5 1.45816L0 33.5415H35L17.5 1.45816ZM16.0417 14.5832H18.9583V23.3332H16.0417V14.5832ZM17.5 28.8019C16.4952 28.8019 15.6771 27.9852 15.6771 26.979C15.6771 25.9727 16.4952 25.1561 17.5 25.1561C18.5048 25.1561 19.3229 25.9727 19.3229 26.979C19.3229 27.9852 18.5048 28.8019 17.5 28.8019Z"
                      fill="#1F78B4"
                    />
                  </svg>
                ) : (
                  <svg
                    className="ml-2"
                    width="35"
                    height="35"
                    viewBox="0 0 35 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.5 0.458313L0 32.5416H35L17.5 0.458313ZM16.0417 12.125H18.9583V22.3333H16.0417V12.125ZM17.5 28.5312C16.4937 28.5312 15.6771 27.7146 15.6771 26.7083C15.6771 25.7021 16.4937 24.8854 17.5 24.8854C18.5063 24.8854 19.3229 25.7021 19.3229 26.7083C19.3229 27.7146 18.5063 28.5312 17.5 28.5312Z"
                      fill="#1F78B4"
                    />
                  </svg>
                )}
                Report
              </div>
              {showModal && statusreport === false ? (
                <div>
                  <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                    <div className="relative my-auto mx-auto lg:max-w-xl md:max-w-lg">
                      {/*content*/}
                      <div
                        className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none"
                        style={{ width: "45vw" }}
                      >
                        {/*header*/}
                        <button
                          type="button"
                          class="text-red-400  font-Montserrat ml-auto bg-transparent font-semibold hover:bg-blue-50   focus:outline-none  rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center  mr-2 mb-2"
                          onClick={() => setShowModal(false)}
                        >
                          <svg
                            className="mr-1"
                            width="12"
                            height="13"
                            viewBox="0 0 12 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 1.5L11 11.5M1 11.5L11 1.5"
                              stroke="#E40000"
                              stroke-opacity="0.6"
                              stroke-width="2"
                            />
                          </svg>
                          Cancel
                        </button>
                        <div className=" ml-3 flex items-start justify-between -mt-8 w-fit rounded-t">
                          <h2 className="font-Montserrat text-xl font-bold text-black">
                            Report a Problem
                          </h2>
                          <button
                            className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                            onClick={() => setShowModal(false)}
                          >
                            <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                              ×
                            </span>
                          </button>
                        </div>

                        {/*body*/}
                        <div className="relative px-6 flex-auto">
                          <div className="flex mt-1 font-Montserrat">
                            <div class=" inline-flex w-16 mt-3 ml-1 mr-2 bg-blue-200 rounded-full h-0.5 "></div>
                            <p className="text-blue-200 font-Montserrat">
                              Details
                            </p>
                          </div>
                          <form className="">
                            <div class="relative z-0 w-3/4 mb-1 group">
                              <input
                                type="text"
                                name="Name"
                                class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer"
                                placeholder="Name of Issue "
                                required
                              />
                            </div>
                            <div class="relative z-0 w-3/4 mb-1 group">
                              <input
                                type="text"
                                name="description"
                                class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer"
                                placeholder="Description "
                                required
                              />
                            </div>
                          </form>
                          {!viewdrawing === undefined ||
                          viewdrawing?.codename === "view_drawing" ? (
                            <div>
                              <h2 class="mt-2 mb-2">
                                <div
                                  class="
                  relative
                  flex
                  items-center
                  w-full
                  py-4
                  font-Montserrat
                  text-base text-blue-200 text-left
                  bg-transparent
                  border-0
                  rounded-none
                  transition
                  focus:outline-none
                  "
                                >
                                  <svg
                                    className="mr-2 hover:rotate-180"
                                    width="15"
                                    height="10"
                                    viewBox="0 0 15 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M13.6582 1.07812L7.50031 7.57812L1.00031 1.07813"
                                      stroke="#1F78B4"
                                      stroke-width="2"
                                    />
                                  </svg>{" "}
                                  Images
                                </div>
                              </h2>
                              <div className="flex mt-2">
                                <div className=" space-x-15 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat">
                                  <div className="flex flex-col bg-gray-200 shadow-lg rounded-lg border-cyan-100 border-1 items-center py-4 font-Montserrat">
                                    <div className="text-center h-16 "></div>
                                  </div>
                                </div>
                                <div className=" space-x-15 ml-8 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat">
                                  <div className="flex flex-col bg-gray-200 shadow-lg rounded-lg border-cyan-100 border-1 items-center py-4 font-Montserrat">
                                    <div className="text-center h-16 "></div>
                                  </div>
                                </div>
                                <div className=" space-x-15 ml-8 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat">
                                  <div className="flex flex-col bg-gray-200 shadow-lg rounded-lg border-cyan-100 border-1 items-center py-4 font-Montserrat">
                                    <div className="text-center h-16 "></div>
                                  </div>
                                </div>
                                <div className=" space-x-15 ml-8 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat">
                                  <div className="flex flex-col bg-gray-200 shadow-lg rounded-lg border-cyan-100 border-1 items-center py-4 font-Montserrat">
                                    <div className="text-center h-16 "></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {!adddrawing === undefined ||
                          adddrawing?.codename === "add_drawing" ? (
                            <div className="flex flex-row mt-8 place-content-center bg-blue-50 border-2 border-blue-200 py-2 space-x-2">
                            <label
                              for="file-input-cover"
                              className="flex flex-wrap cursor-pointer custom-file-upload text-blue-200 font-semibold text-lg"
                            >
                              <svg
                                width="25"
                                height="25"
                                viewBox="0 0 25 25"
                                className="mr-2"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle cx="12.5" cy="12.5" r="12.5" fill="#1F78B4" />
                                <path
                                  d="M6.66406 12.5013H18.3307M12.4974 6.66797V12.5013V18.3346"
                                  stroke="white"
                                  stroke-width="1.66667"
                                />
                              </svg>{" "}
                              Upload Images
                            </label>
                            <input
                              id="file-input-cover"
                              type="file"
                              className="text-blue-200 font-semibold text-lg hidden"
                              name="profile"
                              accept="image/jpeg,image/jpg"
                              onChange={(e) => _handleUploadImage(e, "cover")}
                            />
                            
                          </div>
                          ) : null}
                          <div className="flex mt-2 font-Montserrat">
                            <div class=" inline-flex w-16 mt-3 ml-1 mr-2 bg-blue-200 rounded-full h-0.5 "></div>
                            <p className="text-blue-200 font-Montserrat">
                              Status
                            </p>
                          </div>
                          <form>
                            <div class="relative z-0 w-3/4 mb-2 group">
                              <select
                                id="status"
                                class=" border mt-8 border-gray-200 text-gray-400 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full py-3"
                                placeholder=" "
                                required
                              >
                                <option selected>Report Status</option>
                                <option value="US">Damaged</option>
                                <option value="CA">Repaired</option>
                                <option value="FR">Faulty</option>
                                <option value="DE">Delayed</option>
                              </select>
                            </div>
                          </form>
                        </div>
                        {/*footer*/}
                        <div className="flex px-6 py-2 border-t border-solid border-slate-200 rounded-b">
                          <div className="float-left">
                            <button
                              className="text-red-500  background-transparent text-lg px-6 py-2  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                              type="button"
                              onClick={() => setShowModal(false)}
                            >
                              Cancel
                            </button>
                          </div>
                          <div className="float-right ml-auto">
                            <button
                              className="bg-green-100 hover:bg-green-200 text-white active:bg-emerald-600 font-bold  text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                              type="button"
                              onClick={() => setShowModal(false)}
                            >
                              Report Issue
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </div>
              ) : null}
            </div>
          </div>

          <div className="flex flex-wrap mt-1  ">
            <div className="flex flex-wrap m-auto float-left ">
              <div
                className=" text-blue-200 cursor-pointer py-4 font-medium "
                onClick={() => ButtonprintHandler(!statusprint)}
              >
                {statusprint ? (
                  <svg
                    className="ml-0.5"
                    width="35"
                    height="33"
                    viewBox="0 0 35 33"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M29.1667 5.83333V0H5.83333V5.83333H0V26.25H4.03083L6.94896 20.4167H28.054L30.9706 26.25H35V5.83333H29.1667ZM8.75 2.91667H26.25V5.83333H8.75V2.91667ZM32.0833 21.9552L29.8565 17.5H5.14646L2.91667 21.9567V8.75H32.0833V21.9552ZM26.25 23.3333L30.625 32.0833H4.375L8.75 23.3333H11.9627L9.09271 29.1667H25.9044L23.0519 23.3333H26.25ZM30.625 10.9375C30.625 11.34 30.2983 11.6667 29.8958 11.6667C29.4933 11.6667 29.1667 11.34 29.1667 10.9375C29.1667 10.535 29.4933 10.2083 29.8958 10.2083C30.2983 10.2083 30.625 10.535 30.625 10.9375Z"
                      fill="#1F78B4"
                    />
                  </svg>
                ) : (
                  <svg
                    className="ml-0.5"
                    width="35"
                    height="33"
                    viewBox="0 0 35 33"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M26.25 23.7917L30.625 32.5417H4.375L8.75 23.7917H11.9627L9.09417 29.625H25.9044L23.0519 23.7917H26.25ZM35 6.29171V26.7084H30.9692L28.0525 20.875H6.9475L4.03083 26.7084H0V6.29171H5.83333V0.458374H29.1667V6.29171H35ZM26.25 3.37504H8.75V6.29171H26.25V3.37504ZM32.0833 9.93754C32.0833 9.53504 31.7567 9.20837 31.3542 9.20837C30.9517 9.20837 30.625 9.53504 30.625 9.93754C30.625 10.34 30.9517 10.6667 31.3542 10.6667C31.7567 10.6667 32.0833 10.34 32.0833 9.93754Z"
                      fill="#1F78B4"
                    />
                  </svg>
                )}
                Print
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      {/* <div className='w-full'> <ReactFlow/> </div>
<div className='w-full'> <Editor/> </div>*/}
    </div>
  );
}
